export default {
  maxPortfolio: 'WI04',
  alerts: {
    success: 'success',
    danger: 'danger',
    warning: 'warning',
    info: 'info',
    bell: 'bell',
  },
  assetTypes: {
    bond: 'FIXED_INCOME',
    indexFund: 'INDEX_FUND',
    etf: 'ETF',
  },
  breakpoints: {
    xs: 320,
    sm: 768,
    md: 992,
    lg: 1200,
  },
};
